export enum ControlStateEnum {
  ENABLE = 'enable',
  DISABLE = 'disable',
  HIDEN = 'hiden',
}
